import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-tooltip-1-6-0{left:100%;width:250px;min-height:44px;margin-left:12px;padding:12px;-webkit-transform:translateY(-50%);transform:translateY(-50%);border-radius:5px;color:#444;font-family:Roboto Condensed,Arial,sans-serif;font-size:16px;text-align:center;text-decoration:none;-webkit-box-shadow:0 0 12px rgba(0,0,0,.12);box-shadow:0 0 12px rgba(0,0,0,.12);display:none}.hcr-tooltip-1-6-0,.hcr-tooltip-1-6-0:before{position:absolute;top:50%;background:#fff;z-index:10}.hcr-tooltip-1-6-0:before{left:0;width:15px;height:15px;-webkit-transform:translateY(-50%) translateX(-50%) rotate(45deg);transform:translateY(-50%) translateX(-50%) rotate(45deg);-webkit-box-shadow:-3px 3px 5px rgba(0,0,0,.1);box-shadow:-3px 3px 5px rgba(0,0,0,.1);content:\"\"}.hcr-tooltip--active-1-6-0{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;text-align:left}.hcr-tooltip--left-1-6-0{right:100%;left:auto;margin-right:12px;margin-left:0}.hcr-tooltip--left-1-6-0:before{right:0;left:auto;-webkit-transform:translateY(-50%) translateX(50%) rotate(45deg);transform:translateY(-50%) translateX(50%) rotate(45deg);-webkit-box-shadow:3px -3px 5px rgba(0,0,0,.1);box-shadow:3px -3px 5px rgba(0,0,0,.1)}.hcr-tooltip--top-1-6-0{top:auto;bottom:100%;left:50%;margin-bottom:12px;margin-left:0;-webkit-transform:translateY(0) translateX(-50%);transform:translateY(0) translateX(-50%)}.hcr-tooltip--top-1-6-0:before{top:auto;bottom:0;left:50%;margin-left:0;-webkit-transform:translateY(50%) translateX(-50%) rotate(-45deg);transform:translateY(50%) translateX(-50%) rotate(-45deg)}.hcr-tooltip--bottom-1-6-0{top:100%;left:50%;margin-top:12px;margin-left:0;-webkit-transform:translateY(0) translateX(-50%);transform:translateY(0) translateX(-50%)}.hcr-tooltip--bottom-1-6-0:before{top:0;left:50%;-webkit-transform:translateY(-50%) translateX(-50%) rotate(45deg);transform:translateY(-50%) translateX(-50%) rotate(45deg);-webkit-box-shadow:-3px -3px 5px rgba(0,0,0,.1);box-shadow:-3px -3px 5px rgba(0,0,0,.1)}.hcr-tooltip__close-1-6-0{border:0;background:transparent;font-size:16px;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-align-self:flex-start;-ms-flex-item-align:start;align-self:flex-start;display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M846.4 799.1L535.9 488.6l310.5-310.9a29.1 29.1 0 00-41.4-41.3L494.1 446.8 181.8 136.4a29.5 29.5 0 00-41.3 0 27.3 27.3 0 00-8.7 20.4 28.2 28.2 0 008.7 20.9l314 310.9-312.2 310.9a29.5 29.5 0 0020.9 50 29.1 29.1 0 0018.6-8.6l310.5-310.4 310.9 310.4a29.1 29.1 0 0041.3 0 28.6 28.6 0 001.9-41.8z' fill='rgba(51, 51, 51, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%;background-size:20px}.hcr-tooltip__close-1-6-0 .hcr-icon-1-6-0{display:none}.hcr-tooltip-target-1-6-0{position:relative}",
map:{"hcr-tooltip":"hcr-tooltip-1-6-0","hcr-tooltip--active":"hcr-tooltip--active-1-6-0","hcr-tooltip--left":"hcr-tooltip--left-1-6-0","hcr-tooltip--top":"hcr-tooltip--top-1-6-0","hcr-tooltip--bottom":"hcr-tooltip--bottom-1-6-0","hcr-tooltip__close":"hcr-tooltip__close-1-6-0","hcr-icon":"hcr-icon-1-6-0","hcr-tooltip-target":"hcr-tooltip-target-1-6-0"}};

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      content = _ref.content,
      extraClasses = _ref.extraClasses,
      position = _ref.position,
      active = _ref.active,
      wrapAround = _ref.wrapAround,
      hasClose = _ref.hasClose,
      closeBtn = _ref.closeBtn,
      rest = _objectWithoutProperties(_ref, ["children", "content", "extraClasses", "position", "active", "wrapAround", "hasClose", "closeBtn"]);

  // defines base class name for the window itself
  var bem = Bem('tooltip', styles);
  var bemWrap = Bem('tooltip-target', styles); // stores BEM class names, defines BEM modifiers

  var tooltipWindowClassNames = bem.b({
    active: active,
    top: position === 'top',
    left: position === 'left',
    bottom: position === 'bottom'
  }, extraClasses); // defines class name for the wrapper element
  // @todo this is questionable so can be removed if a cleaner way is found

  var Elem = wrapAround === 'inline' ? 'span' : 'div'; // renders tooltip content depending on the prop type

  var renderContent = function renderContent() {
    return typeof content === 'function' ? content() : content;
  };

  return React.createElement(Elem, _extends({
    className: bemWrap.b()
  }, rest), children, React.createElement("div", {
    className: tooltipWindowClassNames
  }, React.createElement("div", {
    className: bem.e('content')
  }, renderContent()), hasClose && React.createElement("button", _extends({
    type: "button",
    className: bem.e('close')
  }, closeBtn))));
};
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
  children: null,
  extraClasses: '',
  position: null,
  active: false,
  wrapAround: 'inline',
  hasClose: false,
  closeBtn: {}
};
Tooltip.propTypes = {
  children: PropTypes.node,

  /** Custom classes name for tooltip element */
  extraClasses: PropTypes.string,

  /** Controls tooltip positioning, to the right is the default position */
  position: PropTypes.oneOf(['left', 'top', 'bottom']),

  /** Controls if tooltip is shown */
  active: PropTypes.bool,

  /** Defines inline or block behaviour of the wrapper element */
  wrapAround: PropTypes.oneOf(['inline', 'block']),

  /** Specifies tooltip content accepts */
  content: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,

  /** Rest props for the close button (if) hasClose is true */
  closeBtn: PropTypes.object,

  /** Defines if a close control is present */
  hasClose: PropTypes.bool
};
var tooltip = Injecss(Tooltip, styles);

export { tooltip as Tooltip };
